(function () {
  'use strict';

  function initTestimonials(root) {
    if (!root || root.dataset.jhTestimonialsReady === 'true') return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-jh-testimonial]'));
    var previous = root.querySelector('[data-jh-testimonial-prev]');
    var next = root.querySelector('[data-jh-testimonial-next]');
    var count = root.querySelector('[data-jh-testimonial-count]');
    if (!slides.length || !previous || !next) return;
    var active = 0;

    function show(index) {
      active = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        slide.classList.toggle('is-active', slideIndex === active);
      });
      if (count) count.textContent = '0' + (active + 1) + ' / 0' + slides.length;
    }

    previous.addEventListener('click', function () { show(active - 1); });
    next.addEventListener('click', function () { show(active + 1); });
    root.dataset.jhTestimonialsReady = 'true';
    show(0);
  }

  function initMobileAddToCart() {
    if (!document.body.classList.contains('template--product')) return;
    if (document.querySelector('.jh-mobile-atc')) return;

    var productRoot = document.querySelector('#MainContent [data-jh-mobile-atc]');
    if (!productRoot || productRoot.dataset.jhMobileAtc !== 'true') return;
    var originalButton = productRoot && productRoot.querySelector('.main-product__form-submit[name="add"]');
    var title = productRoot && productRoot.querySelector('.main-product__title');
    var price = productRoot && productRoot.querySelector('.main-product__price');
    if (!productRoot || !originalButton || !title || !price) return;

    var bar = document.createElement('div');
    bar.className = 'jh-mobile-atc is-ready';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="jh-mobile-atc__info"><strong></strong><span></span></div><button type="button"></button>';
    var barTitle = bar.querySelector('strong');
    var barPrice = bar.querySelector('.jh-mobile-atc__info span');
    var barButton = bar.querySelector('button');

    function sync() {
      barTitle.textContent = title.textContent.trim();
      barPrice.textContent = price.textContent.replace(/\s+/g, ' ').trim();
      barButton.disabled = originalButton.disabled;
      barButton.textContent = originalButton.disabled ? originalButton.textContent.trim() : 'Add to bag';
    }

    barButton.addEventListener('click', function () {
      originalButton.click();
    });
    document.body.appendChild(bar);
    sync();

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        bar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
      }, { threshold: 0 });
      observer.observe(originalButton);
    } else {
      window.addEventListener('scroll', function () {
        var visible = originalButton.getBoundingClientRect().bottom < 0;
        bar.classList.toggle('is-visible', visible);
        bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      }, { passive: true });
    }

    var syncFrame;
    function scheduleSync() {
      if (syncFrame) return;
      syncFrame = window.requestAnimationFrame(function () {
        syncFrame = null;
        sync();
      });
    }

    var mutationObserver = new MutationObserver(scheduleSync);
    mutationObserver.observe(productRoot, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
  }

  function initPdpDrawerIndicators(root) {
    var scope = root || document;
    var drawers = scope.querySelectorAll ? scope.querySelectorAll('details.jh-pdp-drawer__inner') : [];
    Array.prototype.forEach.call(drawers, function (drawer) {
      if (drawer.dataset.jhDrawerIndicatorReady === 'true') return;
      var indicator = drawer.querySelector('.jh-pdp-drawer__indicator');
      if (!indicator) return;

      function syncIndicator() {
        indicator.style.setProperty('transform', drawer.open ? 'rotate(45deg)' : 'rotate(0deg)', 'important');
      }

      drawer.addEventListener('toggle', syncIndicator);
      drawer.dataset.jhDrawerIndicatorReady = 'true';
      syncIndicator();
    });
  }

  function init(root) {
    var scope = root || document;
    var testimonialSections = scope.querySelectorAll ? scope.querySelectorAll('.jh-testimonials') : [];
    Array.prototype.forEach.call(testimonialSections, initTestimonials);
    initPdpDrawerIndicators(scope);
    initMobileAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
